export default __webpack_public_path__ + "static/0193-5d04424b91d76e6c248ed6724417ae3e.png";